var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{staticClass:"bg-white min-vh-100",attrs:{"image":"/static/img/pro/404.png","description":"页面不存在或已被删除"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }